export default __webpack_public_path__ + "static/media/mobile_number.994654bd.png";